<template>
  <div class="w-full flex flex-col space-y-1">
    <label class="text-sm text-gray-400" v-if="useLabel" :for="$attrs.id">
      {{ label }}
    </label>

    <div class="flex items-center relative text-gray-700">
      <icon-svg
        class="absolute"
        :class="[iconColor, iconClasses]"
        v-if="useIcon"
        :icon="icon"
      />

      <textarea
        v-bind="$attrs"
        :value="value"
        @input="$emit('input', $event.target.value)"
        class="w-full rounded-lg leading-5 border border-gray-200 placeholder-gray-300 bg-white focus:outline-none focus:shadow-outline"
        :class="[customSizeClasses, inputIconClasses]"
      />
    </div>
  </div>
</template>

<script>
import IconSvg from "../IconSvg";

export default {
  name: "BaseTextArea",
  inheritAttrs: false,
  components: {
    IconSvg,
  },
  props: {
    size: {
      default: 2,
      type: Number,
      validator: (value) => {
        const sizes = [1, 2];
        return sizes.includes(value);
      },
    },
    label: {
      default: null,
      type: String,
    },
    value: {
      default: "",
      type: [String, Number],
    },
    icon: {
      default: null,
      type: String,
    },
    iconPosition: {
      default: "right",
      type: String,
      validator: (value) => {
        return value === "left" || value === "right";
      },
    },
    iconColor: {
      default: null,
      type: String,
    },
  },
  computed: {
    customSizeClasses() {
      const size = this.size;

      const small = "text-sm px-3 py-1";
      const base = "text-base px-4 py-2";

      if (size === 1) {
        return small;
      }

      if (size === 2) {
        return base;
      } else {
        return base;
      }
    },
    iconClasses() {
      const iconPosition = this.iconPosition;

      const sizeClass = "w-3";
      const positionClass =
        iconPosition === "left" ? "ml-3 left-0" : "mr-3 right-0";

      return `${sizeClass} ${positionClass}`;
    },
    inputIconClasses() {
      if (!this.useIcon) {
        return null;
      }

      const iconPosition = this.iconPosition;

      return iconPosition === "left" ? "pl-8" : "pr-8";
    },
    iconSize() {
      const size = this.size;
      return size === 2 ? "w-4" : "w-3";
    },
    useLabel() {
      return this.label !== null;
    },
    useIcon() {
      return this.icon !== null;
    },
  },
};
</script>
